import { RegisterUserModel } from '.';
import { formatMessage } from 'src/api';
import MESSAGES from './../../../../app/Pages/Register/Register.messages';

export const registerUserForm = (): RegisterUserModel => ({
  email: {
    autocomplete: 'email',
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.registerMailError}),
    label: formatMessage({...MESSAGES.registerMail}),
    name: 'email',
    type: 'email',
    placeholder: formatMessage({...MESSAGES.registerMail}),
    required: true,
    validation: 'isEmail',
    value: '',
  },
  password: {
    autocomplete: 'new-password',
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.registerPwError}),
    label: formatMessage({...MESSAGES.registerPw}),
    name: 'password',
    type: 'password',
    placeholder: formatMessage({...MESSAGES.registerPw}),
    required: true,
    validation: 'isPassword',
    value: '',
  },
  passwordRepeat: {
    autocomplete: 'new-password',
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.registerPwRepeatError}),
    label: formatMessage({...MESSAGES.registerPwRepeat}),
    name: 'passwordRepeat',
    type: 'password',
    placeholder: formatMessage({...MESSAGES.registerPwRepeat}),
    required: true,
    validation: 'password.Repeat',
    value: '',
  },
});
